import React, { useEffect } from 'react';
import './CalendlySection.css';

const CALENDLY_URL = 'https://calendly.com/office-freshstartscapes/new-meeting';
const CALENDLY_SCRIPT_SRC = 'https://assets.calendly.com/assets/external/widget.js';

const CalendlySection = () => {
  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${CALENDLY_SCRIPT_SRC}"]`);
    if (existingScript) return;

    const script = document.createElement('script');
    script.src = CALENDLY_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <section className="calendly" id="book">
      <div className="calendly__inner">
        <header className="calendly__header">
          <span className="calendly__tag">Let&apos;s Talk</span>
          <h2 className="calendly__heading">
            Book a <span className="calendly__heading-accent">free consultation.</span>
          </h2>
          <p className="calendly__subtext">
            Pick a time that works for you. We&apos;ll walk your property, discuss your
            vision, and provide a detailed proposal - no obligation.
          </p>
        </header>

        <div className="calendly__frame-wrap">
          <div
            className="calendly-inline-widget calendly__widget"
            data-url={CALENDLY_URL}
            style={{ minWidth: '100%', width: '100%', height: '700px' }}
          />
        </div>

        <p className="calendly__fallback">
          Prefer to call? Reach us at <a href="tel:+19706315060">970-631-5060</a>
        </p>
      </div>
    </section>
  );
};

export default CalendlySection;
